// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Lingui from "../../locales/Lingui.re.mjs";
import * as ReactIntl from "react-intl";
import * as React$1 from "@lingui/react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as AppContext from "../layouts/appContext";

function parseLang(loc) {
  return loc.split("-")[0];
}

function parseLocale(loc) {
  return loc.split("-")[1];
}

let make = AppContext.LocaleContext.Provider;

let Provider = {
  make: make
};

let context = AppContext.LocaleContext;

let LocaleContext = {
  Provider: Provider,
  context: context
};

function LangProvider(props) {
  let data = ReactRouterDom.useLoaderData();
  return JsxRuntime.jsx(make, {
    children: JsxRuntime.jsx(React$1.I18nProvider, {
      i18n: Lingui.i18n,
      children: JsxRuntime.jsx(ReactIntl.IntlProvider, {
        locale: data.lang,
        timeZone: data.timezone,
        children: JsxRuntime.jsx(ReactRouterDom.Outlet, {})
      })
    }),
    value: data
  });
}

function make$1(props) {
  let locale = React.useContext(context);
  let newrecord = {...props};
  newrecord.to = props.to.startsWith("/") ? "/" + locale.lang + props.to : props.to;
  return JsxRuntime.jsx(ReactRouterDom.Link, newrecord);
}

let Link = {
  make: make$1
};

function make$2(props) {
  let locale = React.useContext(context);
  let newrecord = {...props};
  newrecord.to = props.to.startsWith("/") ? "/" + locale.lang + props.to : props.to;
  return JsxRuntime.jsx(ReactRouterDom.NavLink, newrecord);
}

let NavLink = {
  make: make$2
};

function make$3(props) {
  let locale = React.useContext(context);
  let newrecord = {...props};
  let newrecord$1 = {...props.to};
  newrecord$1.pathname = Stdlib_Option.map(props.to.pathname, pathname => {
    if (pathname.startsWith("/")) {
      return "/" + locale.lang + pathname;
    } else {
      return pathname;
    }
  });
  newrecord.to = newrecord$1;
  return JsxRuntime.jsx(ReactRouterDom.Link, newrecord);
}

let LinkWithOpts = {
  make: make$3
};

function useLocalePath() {
  let locale = React.useContext(context);
  return path => {
    if (path.startsWith("/")) {
      return "/" + locale.lang + path;
    } else {
      return path;
    }
  };
}

function useNavigate() {
  let navigate = ReactRouterDom.useNavigate();
  let localePath = useLocalePath();
  return (target, opts) => navigate(localePath(target), opts);
}

function useOriginalNavigate(prim) {
  return ReactRouterDom.useNavigate();
}

function useLocation(prim) {
  return ReactRouterDom.useLocation();
}

let Router = {
  Link: Link,
  NavLink: NavLink,
  LinkWithOpts: LinkWithOpts,
  useLocalePath: useLocalePath,
  useNavigate: useNavigate,
  useOriginalNavigate: useOriginalNavigate,
  useLocation: useLocation
};

let make$4 = LangProvider;

export {
  parseLang,
  parseLocale,
  LocaleContext,
  make$4 as make,
  Router,
}
/* make Not a pure module */
